import { useEffect, useSyncExternalStore } from "react";

let tint = null;
const subs = new Set();
const emit = () => subs.forEach((fn) => fn());
export const setPageTint = (v) => { tint = v; emit(); };
export const usePageTint = () => useSyncExternalStore((fn) => { subs.add(fn); return () => subs.delete(fn); }, () => tint);

/* Pages call this to wash the page header with a colour; cleared automatically on unmount. */
export const usePageWash = (color) => {
  useEffect(() => { setPageTint(color); return () => setPageTint(null); }, [color]);
};
